import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidCarIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19.8 9.1 18.4 5c-.4-1.2-1.6-2-2.8-2H8.4C7.2 3 6 3.8 5.6 5.1l-1.4 4C2.9 9.5 2 10.6 2 12v4c0 1.3.8 2.4 2 2.8V20c0 .6.4 1 1 1s1-.4 1-1v-1h12v1c0 .6.4 1 1 1s1-.4 1-1v-1.2c1.2-.4 2-1.5 2-2.8v-4c0-1.4-.9-2.5-2.2-2.9ZM7.5 5.7c.1-.4.5-.7.9-.7h7.1c.4 0 .8.3.9.7L17.6 9H6.4l1.1-3.3ZM7 15c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1Zm6 0h-2c-.6 0-1-.4-1-1s.4-1 1-1h2c.6 0 1 .4 1 1s-.4 1-1 1Zm4 0c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1Z"/>
  </SvgIcon>
}

export default SolidCarIcon
